import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CartegraphMainSetupComponent} from './cartegraph-main-setup/cartegraph-main-setup.component';
import {CartegraphTasksComponent} from './cartegraph-tasks/cartegraph-tasks.component';
import {CartegraphTasksImportComponent} from './cartegraph-tasks-import/cartegraph-tasks-import.component';
import {CartegraphNotificationsComponent} from './cartegraph-notifications/cartegraph-settings-notifications.component';
import {CartegraphSettingsFeaturesComponent} from './cartegraph-features/cartegraph-settings-features.component';
import {
  CartegraphSettingsImportFiltersComponent
} from './cartegraph-import-filters/cartegraph-settings-import-filters.component';
import {
  CartegraphSettingsObservationsMappingComponent
} from './cartegraph-observations-mapping/cartegraph-settings-observations-mapping.component';
import {
  CartegraphSettingsFeaturesMainComponent
} from './cartegraph-features/cartegraph-settings-features-main.component';
import {
  CartegraphTaskActivitySettingsComponent
} from './cartegraph-task-activity-settings/cartegraph-task-activity-settings.component';
import {CartegraphSettingsResourcesComponent} from './cartegraph-resources/cartegraph-settings-resources.component';

const routes: Routes = [
  {
    path: '',
    component: CartegraphTasksComponent,
  },
  {
    path: 'settings',
    component: CartegraphMainSetupComponent,
  },
  {
    path: 'settings/notifications',
    component: CartegraphNotificationsComponent,
  },
  {
    path: 'settings/features',
    component: CartegraphSettingsFeaturesMainComponent,
    children: [
      {
        path: '',
        component: CartegraphSettingsFeaturesComponent,
      },
      {
        path: 'observations-mapping',
        component: CartegraphSettingsObservationsMappingComponent,
      },
      {
        path: 'task-activities',
        component: CartegraphTaskActivitySettingsComponent,
      }
    ]
  },
  {
    path: 'settings/import',
    component: CartegraphSettingsImportFiltersComponent,
  },
  {
    path: 'settings/resources',
    component: CartegraphSettingsResourcesComponent,
  },
  {
    path: 'imports',
    component: CartegraphTasksImportComponent,
  },
  {
    path: 'submissions',
    component: CartegraphTasksComponent,
  }
  ,
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class CartegraphManagementRoutingModule {
}
